import React, { useState } from 'react';
import { notification, Popconfirm, Space, Layout } from 'antd';
import { Link } from 'react-router-dom';

import INTERNAL_LINKS from '../../../enums/InternalLinks';
import MESSAGES from '../../../enums/Messages';
import CustomButton from '../../../components/CustomButton';
import PdfViewer from '../../../components/PdfViewer';

import { ajaxTable, remove } from '../../../api/module/resume_experience';
import { get as getDocumentUrl } from '../../../api/module/document_repository';
import { catchException } from '../../../utils/helpers/helpers';
import AjaxTable from '../../../components/AjaxTable';

const { Content } = Layout;

const OtherCertificationsList = ({ idTercero, readOnly = false }) => {
  const [reloadSource, setReloadSource] = useState(false);
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [showPdf, setShowPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');

  const showClick = async (documento_nombre) => {
    setLoadingDocument(documento_nombre);

    const response = await getDocumentUrl(documento_nombre);

    setPdfUrl(response.data.url);
    setShowPdf(true);
    setLoadingDocument(false);
  };

  const deleteDataSource = async (id) => {
    try {
      setLoadingDelete(id);
      await remove(id);
      setLoadingDelete(false);
      setReloadSource({});
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_DELETE_MSG,
        duration: 2,
      });
    } catch (err) {
      console.log(err);
      setLoadingDelete(false);
      catchException(err, MESSAGES.DESC_ERROR_DELETE_MSG);
    }
  };

  const columns = [
    {
      title: 'Empresa o entidad',
      dataIndex: 'empresa',
      key: 'empresa',
    },
    {
      title: 'Fecha ingreso',
      dataIndex: 'fecha_ingreso',
      key: 'fecha_ingreso',
    },
    {
      title: 'Fecha terminación',
      dataIndex: 'fecha_terminacion',
      key: 'fecha_terminacion',
    },
    {
      title: 'Área de experiencia',
      dataIndex: 'area_experiencia_nombre',
      key: 'area_experiencia_nombre',
    },
    {
      title: 'Cargo',
      dataIndex: 'tipo_cargo_nombre',
      key: 'tipo_cargo_nombre',
    },
    {
      title: 'Consultar documento',
      dataIndex: 'tarjeta_profesional',
      key: 'tarjeta_profesional',
      fixed: 'right',
      width: 120,
      render: (text, record) => {
        if (record.documento_nombre) {
          return (
            <CustomButton
              block
              type="default"
              htmlType="button"
              loading={loadingDocument === record.documento_nombre}
              disabled={loadingDocument}
              onClick={() => {
                showClick(record.documento_nombre);
              }}
              text="Ver"
            />
          );
        }
      },
    },
    {
      title: 'Acción',
      key: 'action',
      fixed: 'right',
      width: 200,
      render: (_, record) =>
        !readOnly ? (
          <Space>
            <CustomButton
              type={'default'}
              className={'ant-btn-info'}
              htmlType="button"
              text={
                <Link
                  to={`${INTERNAL_LINKS.LABOR_CONTRACTORS}/${idTercero}/${record.id}`}
                >
                  Editar
                </Link>
              }
              disabled={loadingDelete}
            />
            <CustomButton
              danger
              type={'default'}
              htmlType="button"
              disabled={loadingDelete}
              loading={loadingDelete === record.id}
              text={
                <Popconfirm
                  title={MESSAGES.DELETE_CONFIRM_MSG}
                  onConfirm={() => deleteDataSource(record.id)}
                >
                  Eliminar
                </Popconfirm>
              }
            />
          </Space>
        ) : null,
    },
  ];

  return (
    <Content>
      {idTercero && (
        <AjaxTable
          columns={columns}
          endpoint={ajaxTable}
          query={idTercero}
          tableTitle="Listado de Experiencia laboral general"
          scroll={{ x: 1100 }}
          reloadSource={reloadSource}
        />
      )}
      <PdfViewer
        pdf={pdfUrl}
        onCancel={() => setShowPdf(false)}
        open={showPdf}
      />
    </Content>
  );
};

export default OtherCertificationsList;
